import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// --- Auth token wiring ------------------------------------------------------
export function setAuthToken(token) {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers.common["Authorization"];
    }
}

// Auto-logout on 401 (except during /auth/login|signup which handle errors locally)
api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        const isAuthEndpoint =
            url.includes("/auth/login") || url.includes("/auth/signup") || url.includes("/auth/me");
        if (status === 401 && !isAuthEndpoint) {
            localStorage.removeItem("elevatebuild_trainee_token");
            delete api.defaults.headers.common["Authorization"];
            if (typeof window !== "undefined" && !window.location.pathname.startsWith("/portal/login")) {
                window.location.href = "/portal/login";
            }
        }
        return Promise.reject(err);
    },
);

// --- Marketing (Phase 1) ----------------------------------------------------
export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchProjects = () => api.get("/projects").then((r) => r.data);
export const fetchProject = (slug) => api.get(`/projects/${slug}`).then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);

// --- Portal (Phase 2) -------------------------------------------------------
export const authApi = {
    signup: (payload) => api.post("/auth/signup", payload).then((r) => r.data),
    login: (payload) => api.post("/auth/login", payload).then((r) => r.data),
    me: () => api.get("/auth/me").then((r) => r.data),
};

export const coursesApi = {
    list: (category) =>
        api
            .get("/courses", category ? { params: { category } } : {})
            .then((r) => r.data),
    get: (slug) => api.get(`/courses/${slug}`).then((r) => r.data),
    enroll: (slug) => api.post(`/courses/${slug}/enroll`).then((r) => r.data),
};

export const lessonsApi = {
    get: (lessonId) => api.get(`/lessons/${lessonId}`).then((r) => r.data),
    complete: (lessonId) => api.post(`/lessons/${lessonId}/complete`).then((r) => r.data),
};

export const meApi = {
    enrollments: () => api.get("/me/enrollments").then((r) => r.data),
    certificates: () => api.get("/me/certificates").then((r) => r.data),
};

export const certificatesApi = {
    get: (id) => api.get(`/certificates/${id}`).then((r) => r.data),
    verify: (slug) => api.get(`/verify/${slug}`).then((r) => r.data),
};

// Re-export helper so pages can use it without pulling AuthContext
export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" · ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
